
<div id="show-student" class="row" *ngIf="!loading">
    <div class="col-sm-3">
      <app-side-bar-guardian-home *ngIf="guardian"
      [guardian]="guardian"
      [target_student_user_id]="0">
    </app-side-bar-guardian-home>
  </div>
    <div class="col-sm-9">
        <app-nav-home-student [linkId]="1" [learner]='learner'></app-nav-home-student>
        <div class="card">
            <div class="card-header">
                <h4 >
                Hello {{learner.fullname}},  {{subscription.name}} {{subscription.level_name}} is calling
                <span  class="pull-right">
                <app-country-flag *ngIf="learner.server_student_id!=0" [countryImage]="learner.countryImage"></app-country-flag>
                </span>
                </h4>
                <app-score-summary *ngIf="learner.server_student_id!=0" [student]="learner"></app-score-summary>

           </div>
        <div class="card-body">
            <div class="row">
                <div class="col-sm-4">
                    <a [routerLink]="['/student/quiz/pending',server_student_user_id,'standard']">
                        <app-card-home-option
                        [cardTitle]="'Standard Quiz Mode'"
                        [imageName]="'aaa.png'"
                        [optionDetail]="pendingStandardQuizCount"></app-card-home-option>

                    </a>
                </div>
                <div class="col-sm-4">
                    <a [routerLink]="['/student/quiz/pending',server_student_user_id,'trivial']">
                        <app-card-home-option
                        [cardTitle]="'Trivial Quiz Mode'"
                        [imageName]="'bbb.png'"
                        [optionDetail]="pendingTrivialQuizCount"></app-card-home-option>

                    </a>
                </div>

                <div class="col-sm-4">
                    <a  [routerLink]="['/area/quiz/modify',server_student_user_id]" class="me-2">
                        <app-card-home-option
                        [cardTitle]="'Change Quiz Topics'"
                        [imageName]="'ddd.png'"
                        [optionDetail]=""></app-card-home-option>
                    </a>
                </div>

                <div class="col-sm-4">
                    <a [routerLink]="['/report/progress/student',server_student_user_id]" >
                        <app-card-home-option
                        [cardTitle]="'Progress Reports'"
                        [imageName]="'fff.png'"
                        [optionDetail]=""></app-card-home-option>
                    </a>


                </div>
            </div>
        <app-quiz-tab-pending *ngIf="server_student_user_id!=0" [server_student_user_id]="server_student_user_id" ></app-quiz-tab-pending>
        </div>
      </div>
    </div>

    </div>
    <div class="=row" *ngIf="learner">
      <div class="col-sm-12">
        <app-student-gift-area *ngIf="maskedGift" [maskedGift]="maskedGift" [learner]="learner"></app-student-gift-area>
    </div>
    </div>
    <app-spinner *ngIf="loading"></app-spinner>

